/* Chef Miau · imagen y CRO de la portada y el resultado del test · v4 (1-oct-2026).
   Fuente: web/test-8oct/ (ESTADO.md). Sin dependencias. No toca el bundle de React: añade piezas
   alrededor de lo que pinta y las vuelve a colocar si React repinta.
   1. Portada: contadores del test de la foto de arriba (mismo canal que el test del muro de correo) y botón
      fijo abajo en móvil mientras el botón amarillo no se ve.
   2. Resultado: tarjetas de receta con foto 4:5, ×N sobre la foto y visor a pantalla completa.
   3. Resultado: banda «En casa», camiseta de regalo (apagada) y póster del vídeo. */
(() => {
  'use strict';
  if (window.CMImgCro) return;
  const LOG = window.__cm8Log = window.__cm8Log || [];
  const RELEASE = 'imgcro_v4_2026_10_01';
  const FILES = 'https://chefmiau.com/cdn/shop/files/';
  const GA4 = 'G-JPLEP8CVXH';
  const note = (type, data) => { try { LOG.push(Object.assign({t: Date.now(), type}, data)); } catch (e) { /* sin registro */ } };
  const isolated = () => { try { return window.CMReview?.isolated === true; } catch (e) { return false; } };
  const themeRole = () => { try { return window.Shopify?.theme?.role || ''; } catch (e) { return ''; } };
  const params = (() => { try { return new URLSearchParams(location.search); } catch (e) { return new URLSearchParams(''); } })();
  // Vista previa (tema sin publicar o revisión aislada): se pueden forzar piezas y, con cm_qa_send=1, dejar que
  // el navegador intente los envíos para comprobarlos (la prueba automática los intercepta; nunca salen).
  const preview = isolated() || (themeRole() !== '' && themeRole() !== 'main');
  const mayMeasure = () => !isolated() && (themeRole() === 'main' || (preview && params.get('cm_qa_send') === '1'));
  const readJSON = node => { try { return JSON.parse((node && node.textContent) || 'null'); } catch (e) { return null; } };
  const config = Object.assign({resultBand: true, tshirt: false, tshirtUrl: ''}, readJSON(document.getElementById('cm-imgcro-config')) || {});
  if (preview && params.get('cm_camiseta') === '1') config.tshirt = true;
  if (preview && params.get('cm_banda') === '0') config.resultBand = false;
  const entry = () => document.getElementById('cm-growth-entry');
  // CM-CORTE-3NOV-20261103: el ángulo de la entrada que se ve (#cm-rh-calc: cata, ración → calidad…); sin ella, el de la entrada vieja.
  const angleNow = () => { const a = document.getElementById('cm-rh-calc')?.dataset.angle || entry()?.dataset.angle || ''; return /^[a-z-]{1,24}$/.test(a) ? a : 'default'; };
  const resultVariant = () => { const c = document.documentElement.classList; return c.contains('cm-review-proposal') ? 'growth' : c.contains('cm-review-current') ? 'current' : ''; };
  const esc = s => String(s).replace(/[&<>"']/g, ch => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[ch]));
  const srcset = (file, native, list) => {
    const widths = list.filter(w => w < native);
    widths.push(Math.min(native, list[list.length - 1]));
    return [...new Set(widths)].map(w => FILES + file + '?width=' + w + ' ' + w + 'w').join(', ');
  };

  // ---------------------------------------------------------------------------------------------
  // 1. Portada · test de la foto de arriba («lifestyle» contra la foto de cada ángulo). La asignación la hace el
  //    script en línea de la sección (window.CMHeroTest). Aquí solo se cuentan, una vez por sesión: vista de portada, primer clic en
  //    «Calcular…» y preguntas terminadas. Mismo canal que el test del muro (client-incident → D1), con el
  //    ángulo en cada marca. Con una ganadora elegida o una carga forzada por URL no se cuenta nada.
  // ---------------------------------------------------------------------------------------------
  const test = window.CMHeroTest;
  const quizRoot = () => document.querySelector('[data-cm-quiz-v2-root]');
  let landing = null;
  if (test && entry() && (test.arm === 'lifestyle' || test.arm === 'angulo')) {
    const counting = !test.forced;
    const cfg = readJSON(document.querySelector('script[type="application/json"][id^="cm-qv2-config-"]')) || {};
    const endpoint = typeof cfg.planCaptureEndpoint === 'string' && /^https:\/\/chef-miau-quiz-plan\.chefmiau\.workers\.dev\/api\/quiz-plan\/?$/.test(cfg.planCaptureEndpoint.trim())
      ? cfg.planCaptureEndpoint.trim().replace(/\/$/, '') : '';
    const sent = new Set();
    const once = key => {
      if (sent.has(key) || (window.__cmHechas && window.__cmHechas[key])) return false; // CM-CORTE-3NOV-20261103: ya lo contó la sección
      sent.add(key);
      try {
        if (sessionStorage.getItem(key) === test.arm) return false;
        sessionStorage.setItem(key, test.arm);
      } catch (e) { /* sin almacenamiento: basta con la memoria de esta carga */ }
      return true;
    };
    const send = (kind, extra) => {
      const reason = ['ab_' + kind, 'hero-' + test.arm, angleNow()].concat(extra ? [extra] : []).join(':').slice(0, 140);
      const row = {reason, counting, sent: false};
      if (counting && mayMeasure() && cfg.planCaptureEnabled === true && endpoint) {
        try {
          fetch(endpoint + '/client-incident', {method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true, referrerPolicy: 'no-referrer',
            headers: {'Content-Type': 'application/json'}, body: JSON.stringify({event: 'quiz_client_error', reason})}).catch(() => undefined);
          row.sent = true;
        } catch (e) { /* un contador perdido no puede romper la portada */ }
      }
      note('ab', row);
    };
    const landingOpen = () => document.documentElement.classList.contains('cm-entry-open') && document.visibilityState !== 'hidden';
    let viewed = false;
    const checkView = () => {
      if (viewed || !landingOpen()) return;
      viewed = true;
      if (once('cm9_hero_view')) send('view');
    };
    let done = false;
    const checkDone = () => {
      if (done) return;
      const root = quizRoot();
      if (!root || !root.querySelector('[class*="_emailStage_"],[class*="_reviewStage_"],[class*="_resultScreen_"],[data-cm-growth-result]')) return;
      done = true;
      let seen = viewed || !!(window.__cmHechas && window.__cmHechas.cm9_hero_view); // CM-CORTE-3NOV-20261103
      try { seen = seen || sessionStorage.getItem('cm9_hero_view') === test.arm; } catch (e) { /* ídem */ }
      if (seen && once('cm9_hero_complete')) send('complete');
    };
    window.addEventListener('cm-growth:start', event => {
      const source = event?.detail?.via === 'sticky' ? 'sticky' : (String(event?.detail?.source || 'landing').replace(/^landing_?/, '') || 'landing');
      if (once('cm9_hero_start')) send('start', /^[a-z_]{1,20}$/.test(source) ? source : 'landing');
    });
    try { new MutationObserver(checkView).observe(document.documentElement, {attributes: true, attributeFilter: ['class']}); } catch (e) { /* ídem */ }
    document.addEventListener('visibilitychange', checkView);
    window.addEventListener('cm-quiz:measurement-ready', checkView);
    checkView();
    landing = {checkView, checkDone};
    entry().setAttribute('data-cm9-ready', '1');
  }

  // ---------------------------------------------------------------------------------------------
  // 1b. Portada · botón fijo abajo (solo en móvil; el css lo esconde en escritorio). Aparece mientras el botón
  //     amarillo de arriba no se ve y la portada está abierta, y se esconde si en pantalla hay otro botón
  //     «Calcular…». Arranca el test igual que el botón de arriba (evento cm-growth:start con origen landing_hero,
  //     que es lo único que acepta la medición de GA4/Meta); el contador del test lo separa como «sticky».
  // ---------------------------------------------------------------------------------------------
  (() => {
    try {
      const root = entry();
      const hero = root && root.querySelector('.cmg2-hero [data-cmg2-start]');
      if (!root || !hero || !root.classList.contains('cmj-journey') || typeof IntersectionObserver !== 'function') return;
      const bar = document.createElement('div');
      bar.className = 'cm9-sticky';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<button type="button" tabindex="-1"><span></span><span aria-hidden="true">→</span></button>';
      const btn = bar.querySelector('button');
      const first = hero.firstChild && hero.firstChild.nodeType === 3 ? hero.firstChild.nodeValue.trim() : '';
      btn.firstChild.textContent = first || 'Calcular su plan y precio · 2 min';
      document.body.appendChild(bar);
      const others = [...root.querySelectorAll('[data-cmg2-start]')].filter(b => b !== hero);
      const seen = new Map();
      let heroVisible = true;
      const paint = () => {
        const open = document.documentElement.classList.contains('cm-entry-open');
        const on = open && !heroVisible && !others.some(b => seen.get(b));
        if (on) { bar.setAttribute('data-on', ''); bar.removeAttribute('aria-hidden'); btn.tabIndex = 0; }
        else { bar.removeAttribute('data-on'); bar.setAttribute('aria-hidden', 'true'); btn.tabIndex = -1; }
      };
      // «Se ve» = al menos media altura del botón en pantalla: una tira de 9 px de amarillo abajo no cuenta.
      const io = new IntersectionObserver(items => {
        for (const item of items) {
          const shown = item.isIntersecting && item.intersectionRatio >= 0.5;
          if (item.target === hero) heroVisible = shown; else seen.set(item.target, shown);
        }
        paint();
      }, {threshold: [0, 0.5, 1]});
      io.observe(hero);
      others.forEach(b => io.observe(b));
      new MutationObserver(paint).observe(document.documentElement, {attributes: true, attributeFilter: ['class']});
      btn.addEventListener('click', () => {
        window.dispatchEvent(new CustomEvent('cm-growth:start', {detail: {angle: angleNow(), source: 'landing_hero', via: 'sticky'}}));
      });
      note('sticky', {ready: true});
    } catch (error) { note('error', {where: 'sticky', message: String(error && error.message || error)}); }
  })();

  // ---------------------------------------------------------------------------------------------
  // 1c. Portada · «← Volver» (Victor, 1-oct): si se llega desde otra página de chefmiau.com (la Tienda, una ficha…),
  //     una píldora junto al logo vuelve atrás. Quien llega de un anuncio o escribe la dirección no la ve.
  //     Va justo después del logo: el logo y «Ya soy cliente» no se mueven (sin salto de maquetación).
  // ---------------------------------------------------------------------------------------------
  (() => {
    try {
      const bar = document.querySelector('#cm-growth-entry .cmg2-brand');
      if (!bar || bar.querySelector('.cmg2-back') || !document.referrer) return;
      const ref = new URL(document.referrer);
      if (ref.host !== location.host || /\/pages\/calcular-tu-plan/.test(ref.pathname)) return;
      const back = document.createElement('a');
      back.className = 'cmg2-back';
      back.href = ref.pathname + ref.search;
      back.textContent = '← Volver';
      back.setAttribute('aria-label', 'Volver a la página anterior');
      back.addEventListener('click', (event) => {
        if (history.length > 1) { event.preventDefault(); history.back(); }
      });
      bar.insertBefore(back, bar.querySelector('.cmg2-brand-right'));
    } catch (e) { /* referrer ilegible: no se pinta */ }
  })();

  // ---------------------------------------------------------------------------------------------
  // Medición del resultado: la misma del test (GA4 con su consentimiento y eventos de cliente de Shopify).
  // Primero se intenta por la capa de medición del bundle; si no admite el evento, se envía por sus mismas vías:
  // gtag('event', ...) y Shopify.analytics.publish('cm_...'), solo con consentimiento de analítica, en el tema
  // publicado y nunca en la revisión aislada.
  // ---------------------------------------------------------------------------------------------
  function track(name, params) {
    const payload = Object.assign({cm_release: RELEASE, measurement_schema: 1, landing_angle: angleNow()}, params || {});
    const rv = resultVariant();
    if (rv) payload.result_variant = rv;
    const row = {t: Date.now(), type: 'event', name, payload, via: 'none'};
    try { LOG.push(row); } catch (e) { /* sin registro */ }
    try {
      const m = window.ChefMiauQuizMeasurement;
      if (m && typeof m.emit === 'function' && m.emit(name, params || {}) === true) { row.via = 'bundle'; return; }
    } catch (e) { /* sigue por la vía directa */ }
    if (!mayMeasure()) return;
    let allowed = false;
    try { allowed = window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; } catch (e) { allowed = false; }
    if (!allowed) { row.via = 'no-consent'; return; }
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, Object.assign({}, payload, {send_to: GA4, page_location: location.origin + location.pathname}));
        row.via = 'gtag';
      }
    } catch (e) { /* ídem */ }
    try {
      const a = window.Shopify?.analytics;
      if (a && typeof a.publish === 'function') {
        const r = a.publish('cm_' + name, payload);
        if (r && typeof r.catch === 'function') r.catch(() => undefined);
        row.via += '+publish';
      }
    } catch (e) { /* ídem */ }
  }

  // ---------------------------------------------------------------------------------------------
  // 2. Resultado · «Su caja, por dentro» estilo ficha (B2).
  // ---------------------------------------------------------------------------------------------
  const JARS = {
    pollo: {file: 'tarro-pollo-calabaza-hd-4x5.jpg', w: 1261},
    pavo: {file: 'tarro-pavo-judias-hd-4x5.jpg', w: 1251},
    ternera: {file: 'tarro-ternera-shiitake-hd-4x5.jpg', w: 1251},
    cerdo: {file: 'tarro-cerdo-zanahoria-hd-4x5.jpg', w: 908}
  };
  const quantityOf = li => {
    const q = li.querySelector('[class*="_quantity_"]');
    const n = q ? parseInt(String(q.textContent || '').replace(/[^0-9]+/g, ' ').trim().split(' ')[0], 10) : NaN;
    return Number.isFinite(n) && n > 0 ? n : 0;
  };
  const recipeText = li => {
    const name = (li.querySelector('[class*="_recipeHead_"] h4')?.textContent || '').trim();
    const detail = (li.querySelector('[class*="_recipeHead_"] p')?.textContent || '').trim();
    return {name, detail, full: (name + (detail ? ' ' + detail : '')).trim()};
  };
  const tarros = n => n === 1 ? '1 tarro de 320 g' : n + ' tarros de 320 g';

  function enhanceCards(scope) {
    for (const li of scope.querySelectorAll('[data-cm-recipe-allocation] li[data-cm-allocation-recipe]')) {
      const id = li.dataset.cmAllocationRecipe;
      const jar = JARS[id];
      if (!jar || !li.querySelector('[class*="_recipeHead_"]')) continue;
      const text = recipeText(li);
      let pack = null;
      for (const child of li.children) if (child.classList && child.classList.contains('cm8-pack')) pack = child;
      if (!pack) {
        pack = document.createElement('div');
        pack.className = 'cm8-pack';
        pack.innerHTML = '<figure class="cm8-pack__photo"><img src="' + FILES + jar.file + '?width=270" srcset="' + srcset(jar.file, jar.w, [180, 270, 360]) +
          '" sizes="104px" width="104" height="130" loading="lazy" decoding="async" alt=""><span class="cm8-pack__qty" aria-hidden="true"></span></figure>' +
          '<button type="button" class="cm8-pack__open">Ver el tarro<span aria-hidden="true">→</span></button>';
        pack.querySelector('button').addEventListener('click', event => openViewer(li.dataset.cmAllocationRecipe, event.currentTarget));
        li.insertBefore(pack, li.firstChild);
        li.setAttribute('data-cm8', '');
      }
      const img = pack.querySelector('img');
      const alt = 'Tarro de 320 g de Chef Miau: ' + (text.full || id);
      if (img && img.getAttribute('alt') !== alt) img.setAttribute('alt', alt);
      const btn = pack.querySelector('button');
      const label = 'Ver el tarro de ' + (text.name || id) + ' a pantalla completa';
      if (btn && btn.getAttribute('aria-label') !== label) btn.setAttribute('aria-label', label);
      const badge = pack.querySelector('.cm8-pack__qty');
      const n = quantityOf(li);
      const want = n ? '×' + n : '';
      if (badge && badge.textContent !== want) badge.textContent = want;
    }
  }

  // Visor a pantalla completa con las recetas de su plan (se desliza).
  let viewer = null;
  function openViewer(startId, opener) {
    try {
      if (viewer) viewer.close(false);
      const section = opener?.closest('[data-cm-recipe-allocation]') || document.querySelector('[data-cm-recipe-allocation]');
      if (!section) return;
      const monthly = !!section.querySelector('[data-cm-box-period="monthly"][aria-pressed="true"]');
      const items = [...section.querySelectorAll('li[data-cm-allocation-recipe]')]
        .map(li => Object.assign({id: li.dataset.cmAllocationRecipe, qty: quantityOf(li)}, recipeText(li)))
        .filter(item => JARS[item.id] && item.qty > 0);
      if (!items.length) return;
      let current = Math.max(0, items.findIndex(item => item.id === startId));
      const box = monthly ? 'Tu caja mensual' : 'Tu primera caja';
      const where = monthly ? 'en tu caja mensual' : 'en tu primera caja';
      const period = monthly ? 'monthly' : 'first';
      const root = document.createElement('div');
      root.className = 'cm8-viewer';
      root.setAttribute('role', 'dialog');
      root.setAttribute('aria-modal', 'true');
      root.setAttribute('aria-labelledby', 'cm8-viewer-title');
      const many = items.length > 1;
      root.innerHTML =
        '<div class="cm8-viewer__bar"><p class="cm8-viewer__title" id="cm8-viewer-title">' + esc(box + ' · ' + items.length + (items.length === 1 ? ' receta' : ' recetas')) + '</p>' +
        '<button type="button" class="cm8-viewer__close" aria-label="Cerrar"><svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button></div>' +
        '<ul class="cm8-viewer__track" aria-label="' + esc(monthly ? 'Recetas de tu caja mensual' : 'Recetas de tu primera caja') + '">' +
        items.map((item, i) => {
          const jar = JARS[item.id];
          return '<li class="cm8-viewer__slide" aria-roledescription="diapositiva" aria-label="' + (i + 1) + ' de ' + items.length + '">' +
            '<figure class="cm8-viewer__photo"><img src="' + FILES + jar.file + '?width=720" srcset="' + srcset(jar.file, jar.w, [480, 720, 960, 1200]) +
            '" sizes="(max-width: 700px) calc(100vw - 40px), 480px" width="' + jar.w + '" height="' + Math.round(jar.w * 1.25) + '" decoding="async" alt="' +
            esc('Tarro de 320 g de Chef Miau: ' + item.full) + '"><span class="cm8-viewer__qty" aria-hidden="true">×' + item.qty + '</span></figure>' +
            '<div class="cm8-viewer__caption"><p class="cm8-viewer__name">' + esc(item.full) + '</p><p class="cm8-viewer__sub">' + esc(tarros(item.qty) + ' ' + where) + '</p></div></li>';
        }).join('') + '</ul>' +
        '<div class="cm8-viewer__foot">' + (many
          ? '<button type="button" class="cm8-viewer__nav" data-dir="-1" aria-label="Receta anterior">←</button><div class="cm8-viewer__dots" aria-hidden="true">' +
            items.map(() => '<i></i>').join('') + '</div><span class="cm8-viewer__hint" aria-hidden="true">desliza →</span>' +
            '<button type="button" class="cm8-viewer__nav" data-dir="1" aria-label="Receta siguiente">→</button>'
          : '') + '</div><p class="cm8-sr" aria-live="polite"></p>';
      const track_ = root.querySelector('.cm8-viewer__track');
      const live = root.querySelector('.cm8-sr');
      const dots = [...root.querySelectorAll('.cm8-viewer__dots i')];
      const navs = [...root.querySelectorAll('.cm8-viewer__nav')];
      const paint = () => {
        dots.forEach((dot, i) => { if (i === current) dot.setAttribute('data-on', ''); else dot.removeAttribute('data-on'); });
        navs.forEach(nav => { const d = Number(nav.dataset.dir); nav.disabled = current + d < 0 || current + d > items.length - 1; });
        live.textContent = 'Receta ' + (current + 1) + ' de ' + items.length + ': ' + items[current].full + '. ' + tarros(items[current].qty) + ' ' + where + '.';
      };
      let lastMethod = 'swipe';
      const settle = () => {
        const w = track_.clientWidth || 1;
        const index = Math.max(0, Math.min(items.length - 1, Math.round(track_.scrollLeft / w)));
        if (index === current) return;
        const from = current;
        current = index;
        paint();
        track('quiz_jar_viewer_swipe', {recipe: items[index].id, position: index + 1, from_position: from + 1, direction: index > from ? 'next' : 'prev',
          period, recipes_count: items.length, method: lastMethod});
        lastMethod = 'swipe';
      };
      let timer = 0;
      track_.addEventListener('scroll', () => { window.clearTimeout(timer); timer = window.setTimeout(settle, 110); }, {passive: true});
      track_.addEventListener('scrollend', () => { window.clearTimeout(timer); settle(); });
      const go = (dir, method) => {
        const target = Math.max(0, Math.min(items.length - 1, current + dir));
        if (target === current) return;
        lastMethod = method;
        track_.scrollTo({left: target * track_.clientWidth, behavior: 'smooth'});
      };
      navs.forEach(nav => nav.addEventListener('click', () => go(Number(nav.dataset.dir), 'button')));
      const html = document.documentElement;
      const previousFocus = opener || document.activeElement;
      const onKey = event => {
        if (event.key === 'Escape') { event.preventDefault(); close(true); return; }
        if (event.key === 'ArrowRight') { event.preventDefault(); go(1, 'key'); return; }
        if (event.key === 'ArrowLeft') { event.preventDefault(); go(-1, 'key'); return; }
        if (event.key === 'Tab') {
          const focusables = [...root.querySelectorAll('button:not([disabled])')].filter(b => b.offsetParent !== null);
          if (!focusables.length) return;
          const first = focusables[0], last = focusables[focusables.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
          else if (!root.contains(document.activeElement)) { event.preventDefault(); first.focus(); }
        }
      };
      function close(restore) {
        document.removeEventListener('keydown', onKey, true);
        html.classList.remove('cm8-viewer-open');
        root.remove();
        viewer = null;
        if (restore && previousFocus && typeof previousFocus.focus === 'function') { try { previousFocus.focus({preventScroll: true}); } catch (e) { /* ídem */ } }
      }
      root.querySelector('.cm8-viewer__close').addEventListener('click', () => close(true));
      document.addEventListener('keydown', onKey, true);
      html.classList.add('cm8-viewer-open');
      document.body.appendChild(root);
      track_.style.scrollBehavior = 'auto';
      track_.scrollLeft = current * track_.clientWidth;
      track_.style.scrollBehavior = '';
      paint();
      viewer = {close, root};
      try { root.querySelector('.cm8-viewer__close').focus({preventScroll: true}); } catch (e) { /* ídem */ }
      track('quiz_jar_viewer_open', {recipe: items[current].id, position: current + 1, period, recipes_count: items.length});
    } catch (error) {
      note('error', {where: 'viewer', message: String(error && error.message || error)});
    }
  }

  // ---------------------------------------------------------------------------------------------
  // 3. Resultado · banda «En casa», camiseta (B6, apagada) y póster del vídeo (B4).
  // ---------------------------------------------------------------------------------------------
  const HOME_ALT = 'Persona de espaldas con la camiseta El toque final abrazando a un gato dorado';
  function resultBand(scope) {
    const result = scope.querySelector('[data-cm-growth-result]');
    if (!result) return;
    const existing = result.querySelector('.cm8-home-result');
    if (!config.resultBand) { if (existing) existing.remove(); return; }
    const after = result.querySelector('section[aria-label="Cómo abrir el tarro"]') || result.querySelector('[class*="_productVideo_"]');
    const before = after ? null : (result.querySelector('[class*="_continuation_"]') || result.querySelector('[class*="_doubts_"]'));
    if (!after && !before) return;
    if (existing && ((after && existing.previousElementSibling === after) || (before && existing.nextElementSibling === before))) return;
    const band = existing || document.createElement('section');
    if (!existing) {
      band.className = 'cm8-home-result';
      band.setAttribute('aria-labelledby', 'cm8-home-result-title');
      band.innerHTML = '<figure><img src="' + FILES + 'camiseta-abrazo-hd-4x5.jpg?width=400" srcset="' + srcset('camiseta-abrazo-hd-4x5.jpg', 3040, [240, 400, 600, 800, 1100]) +
        '" sizes="(max-width: 700px) 112px, 300px" width="3040" height="3800" loading="lazy" decoding="async" alt="' + esc(HOME_ALT) + '"></figure>' +
        '<div class="cm8-home-result__copy"><p class="cm8-home-result__eyebrow">EN CASA</p><h3 id="cm8-home-result-title">Es de casa. Que coma como en casa.</h3>' +
        '<p class="cm8-home-result__text">Te espera en la puerta, se queda con el mejor sitio del sofá y sabe cuándo necesitas compañía. Por eso su comida se cocina a fuego lento, con carne que reconoces, y en la ración que acabamos de calcular.</p></div>';
    }
    if (after) after.after(band); else before.before(band);
  }

  function tshirt(scope) {
    const result = scope.querySelector('[data-cm-growth-result]');
    if (!result) return;
    const existing = result.querySelector('.cm8-tee');
    if (!config.tshirt) { if (existing) existing.remove(); return; }
    const perks = result.querySelector('[class*="_action_"] [class*="_decisionPerks_"]');
    const cta = result.querySelector('[class*="_action_"] [class*="_primaryButton_"]');
    const anchor = perks || cta;
    if (!anchor) return;
    if (existing && existing.previousElementSibling === anchor) return;
    const card = existing || document.createElement('aside');
    if (!existing) {
      card.className = 'cm8-tee';
      card.setAttribute('aria-label', 'Camiseta de regalo');
      const url = typeof config.tshirtUrl === 'string' && /^(https:\/\/|\/)/.test(config.tshirtUrl) ? config.tshirtUrl : '';
      card.innerHTML = '<img src="' + FILES + 'camiseta-estampado-hd-1x1.jpg?width=128" srcset="' + srcset('camiseta-estampado-hd-1x1.jpg', 1640, [128, 192]) +
        '" sizes="64px" width="64" height="64" loading="lazy" decoding="async" alt="Estampado de la camiseta El toque final">' +
        '<div><p class="cm8-tee__eyebrow">De regalo · oferta limitada</p><p class="cm8-tee__title">Camiseta «El toque final»</p>' +
        '<p class="cm8-tee__text">Con tu suscripción. Talla única M.</p><p class="cm8-tee__terms">Hasta agotar existencias · ' +
        (url ? '<a href="' + esc(url) + '" target="_blank" rel="noopener">Ver condiciones</a>' : 'Ver condiciones') + '</p></div>';
    }
    anchor.after(card);
  }

  const POSTER_THUMB = FILES + 'abrir-tarro-video-miniatura-3x4.jpg';
  const POSTER_FULL = FILES + 'abrir-tarro-video-poster-9x16.jpg?width=720';
  function videoPoster(scope) {
    const section = scope.querySelector('section[aria-label="Cómo abrir el tarro"]');
    if (!section) return;
    const img = section.querySelector('[class*="_poster_"] img');
    if (img && !img.hasAttribute('data-cm8')) {
      img.setAttribute('data-cm8', '');
      img.setAttribute('srcset', POSTER_THUMB + '?width=128 128w, ' + POSTER_THUMB + '?width=192 192w, ' + POSTER_THUMB + '?width=256 256w');
      img.setAttribute('sizes', '64px');
      img.setAttribute('src', POSTER_THUMB + '?width=192');
    }
    const video = section.querySelector('video');
    if (video && video.getAttribute('poster') !== POSTER_FULL) video.setAttribute('poster', POSTER_FULL);
  }

  // ---------------------------------------------------------------------------------------------
  // Bucle: una pasada por fotograma como mucho, solo si algo ha cambiado dentro del test.
  // ---------------------------------------------------------------------------------------------
  let queued = false;
  const tick = () => {
    queued = false;
    const scope = quizRoot() || document.body;
    const steps = [['cards', enhanceCards], ['band', resultBand], ['tshirt', tshirt], ['poster', videoPoster]];
    for (const [where, fn] of steps) {
      try { fn(scope); } catch (error) { note('error', {where, message: String(error && error.message || error)}); }
    }
    if (landing) { try { landing.checkDone(); } catch (error) { note('error', {where: 'complete', message: String(error && error.message || error)}); } }
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || window.setTimeout)(tick);
  };
  try {
    const target = quizRoot() || document.body;
    new MutationObserver(schedule).observe(target, {childList: true, subtree: true, characterData: true});
  } catch (e) { /* sin observador no hay mejoras, pero la página sigue igual */ }
  schedule();

  window.CMImgCro = Object.freeze({release: RELEASE, config: Object.freeze(Object.assign({}, config)), log: LOG, openViewer});
})();
